module.exports = __webpack_public_path__ + "img/icon-letter-a.a0d1c12a.svg";